// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Profile layout only. Cards, buttons, badges and the avatar are \`ui-*\`
 * primitives from siteShell.css; this file sets the column, the header row
 * and the two detail blocks inside the panel.
 */

.ProfilePage_page__bnlfh {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: var(--space-6) var(--gutter) var(--space-16);
  box-sizing: border-box;
}

.ProfilePage_header__pqQk5 {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.ProfilePage_headerText__gyFqY {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.ProfilePage_title__0xfuP {
  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  color: var(--text-primary);
}

.ProfilePage_subtitle__6pA7P {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 62ch;
}

.ProfilePage_actions__DO3ow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

/* A settings group: one quiet heading over the cards that belong to it. */
.ProfilePage_stack__Kcb4E {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.ProfilePage_groupTitle__TcaUX {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

/* Panel: sections divided by one hairline, never by nested cards. */
section.ProfilePage_panel__hg7v- {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ProfilePage_section__oTNbm {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-6) 0;
}

.ProfilePage_section__oTNbm:first-child {
  padding-top: 0;
}

.ProfilePage_section__oTNbm:last-child {
  padding-bottom: 0;
}

.ProfilePage_section__oTNbm + .ProfilePage_section__oTNbm {
  border-top: 1px solid var(--border-light);
}

.ProfilePage_sectionHead__pFOp6 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ProfilePage_sectionTitle__OmiXI {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--text-primary);
}

.ProfilePage_sectionHint__0QFvZ {
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

/* -------------------------------------------------------------- Identity */
.ProfilePage_identityRow__epc-Q {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.ProfilePage_avatar__UVbc3 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 66px;
  height: 66px;
  border-radius: var(--radius-full);
  overflow: hidden;
  background: var(--primary);
  color: var(--text-on-primary);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.ProfilePage_avatar__UVbc3 img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ProfilePage_idText__ofLFo {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ProfilePage_name__H1wB1 {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--text-primary);
}

.ProfilePage_email__UO0tB {
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 44ch;
}

.ProfilePage_uploadRow__i7eyW {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.ProfilePage_fileInput__RTsvX {
  display: none;
}

/* ------------------------------------------------------------ Detail grid */
/* Read-only facts: label above value, one hairline per row, no boxes. */
.ProfilePage_metaGrid__yiemu {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
}

@media (min-width: 640px) {
  .ProfilePage_metaGrid__yiemu {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: var(--space-8);
  }
}

.ProfilePage_field__POsTn {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border-light);
  min-width: 0;
}

.ProfilePage_label__gHLh- {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.ProfilePage_value__ulz9U {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 560px) {
  .ProfilePage_page__bnlfh {
    padding: var(--space-5) var(--gutter) var(--space-12);
  }

  .ProfilePage_actions__DO3ow {
    width: 100%;
  }

  .ProfilePage_actions__DO3ow > * {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Profile/ProfilePage.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,6EAA6E;AAC7E,wEAAwE;AACxE;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE;IACE,gDAAgD;IAChD,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/*\n * Profile layout only. Cards, buttons, badges and the avatar are `ui-*`\n * primitives from siteShell.css; this file sets the column, the header row\n * and the two detail blocks inside the panel.\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: var(--space-6) var(--gutter) var(--space-16);\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.headerText {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.title {\n  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  color: var(--text-primary);\n}\n\n.subtitle {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 62ch;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n/* A settings group: one quiet heading over the cards that belong to it. */\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.groupTitle {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n/* Panel: sections divided by one hairline, never by nested cards. */\nsection.panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  padding: var(--space-6) 0;\n}\n\n.section:first-child {\n  padding-top: 0;\n}\n\n.section:last-child {\n  padding-bottom: 0;\n}\n\n.section + .section {\n  border-top: 1px solid var(--border-light);\n}\n\n.sectionHead {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.sectionTitle {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.sectionHint {\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n/* -------------------------------------------------------------- Identity */\n.identityRow {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n}\n\n.avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 66px;\n  height: 66px;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.avatar img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.idText {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.name {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.email {\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 44ch;\n}\n\n.uploadRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.fileInput {\n  display: none;\n}\n\n/* ------------------------------------------------------------ Detail grid */\n/* Read-only facts: label above value, one hairline per row, no boxes. */\n.metaGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0;\n}\n\n@media (min-width: 640px) {\n  .metaGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: var(--space-8);\n  }\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: var(--space-3) 0;\n  border-bottom: 1px solid var(--border-light);\n  min-width: 0;\n}\n\n.label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.value {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 560px) {\n  .page {\n    padding: var(--space-5) var(--gutter) var(--space-12);\n  }\n\n  .actions {\n    width: 100%;\n  }\n\n  .actions > * {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ProfilePage_page__bnlfh`,
	"header": `ProfilePage_header__pqQk5`,
	"headerText": `ProfilePage_headerText__gyFqY`,
	"title": `ProfilePage_title__0xfuP`,
	"subtitle": `ProfilePage_subtitle__6pA7P`,
	"actions": `ProfilePage_actions__DO3ow`,
	"stack": `ProfilePage_stack__Kcb4E`,
	"groupTitle": `ProfilePage_groupTitle__TcaUX`,
	"panel": `ProfilePage_panel__hg7v-`,
	"section": `ProfilePage_section__oTNbm`,
	"sectionHead": `ProfilePage_sectionHead__pFOp6`,
	"sectionTitle": `ProfilePage_sectionTitle__OmiXI`,
	"sectionHint": `ProfilePage_sectionHint__0QFvZ`,
	"identityRow": `ProfilePage_identityRow__epc-Q`,
	"avatar": `ProfilePage_avatar__UVbc3`,
	"idText": `ProfilePage_idText__ofLFo`,
	"name": `ProfilePage_name__H1wB1`,
	"email": `ProfilePage_email__UO0tB`,
	"uploadRow": `ProfilePage_uploadRow__i7eyW`,
	"fileInput": `ProfilePage_fileInput__RTsvX`,
	"metaGrid": `ProfilePage_metaGrid__yiemu`,
	"field": `ProfilePage_field__POsTn`,
	"label": `ProfilePage_label__gHLh-`,
	"value": `ProfilePage_value__ulz9U`
};
export default ___CSS_LOADER_EXPORT___;
